import ManualTrade from './ManualTrade';

export default ManualTrade;
